/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal Pre-Auth
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ResumeImpersonatedUser } from './resume-impersonated-user';

/**
 * 
 * @export
 * @interface ResumeCheckResult
 */
export interface ResumeCheckResult {
    /**
     * 
     * @type {string}
     * @memberof ResumeCheckResult
     */
    result: ResumeCheckResultResultEnum;
    /**
     * Only from redeem, and only when the result is restore and an address was saved and passes its checks. Otherwise go to the home page. 
     * @type {string}
     * @memberof ResumeCheckResult
     */
    url?: string;
    /**
     * 
     * @type {ResumeImpersonatedUser}
     * @memberof ResumeCheckResult
     */
    impersonatedUser?: ResumeImpersonatedUser;
}

/**
    * @export
    * @enum {string}
    */
export enum ResumeCheckResultResultEnum {
    restore = 'restore',
    different_user = 'different-user',
    gone = 'gone',
    impersonation_choice = 'impersonation-choice',
    impersonation_ended = 'impersonation-ended'
}



